import env from "./env";

const Post = {
  Login: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/login", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  VerifyOtp: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/verify", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  assignNumber: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/assign-number", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  SendMessage: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/vehicle-message", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  AddToCart: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/cart", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateQuantity: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/cart/update-quantity", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CheckCart: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/cart/check-cart", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Rating: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/rating", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  AddVehicle: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/vehicle", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  PlaceOrder: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/place_order", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DeleteVehicle: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/vehicle/" + id, {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DeleteAddress: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/address/" + id, {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DeleteNotification: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/notification/" + id, {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CreditCardNetwork: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/credit_cards/networks", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DthOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/dth", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ElectricityOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/electricity", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  WaterOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/water", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  GasOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/gas", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  PostpaidOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/postpaid", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  PrepaidOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/prepaid", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  LpgOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/lpg", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  LoanOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/loan_repay", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  LifeInsuranceOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/insurance", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  LandlineOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/landline", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  FastagOperator: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/fastag", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DthPlans: (circle, paysprintId) => {
    console.log("circle", circle);

    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/dth/plans", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify({
            paysprint_id: paysprintId,
            circle: circle,
          }),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  HlrCheck: (number) => {
    console.log("number", number);

    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/hlr/check", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(number),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  HlrDthData: (number, operator) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/dth/hlr-data", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(number, operator),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  BillFetch: (canumber, paysprintId, ad1 = '', ad2 = '', ad3 = '') => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/bill_fetch", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify({
            operator_id: paysprintId,
            canumber: canumber,
            ad1: ad1,
            ad2: ad2,
            ad3: ad3,
          }),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  PaymentLink: (amount) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/payment-gateway", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify({
            amount,
          }),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CheckPuc: (vehicleNo) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(`${env.url}/puc?number=${vehicleNo}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CheckChallan: (vehicleNo) => {
    return new Promise((resolve, reject) => {
      console.log(
        "url -----",
        vehicleNo,
        `${env.url}/challan?number=${vehicleNo}`
      );
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(`${env.url}/challan?number=${vehicleNo}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CreditCardOtp: (data) => {
    console.log("credit card otp", data);

    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/credit_card/otp", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CreditCardLead: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/credit_card", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateUserProfile: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/user", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddMember: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/add-member", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddMembers: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/add-members", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddStudent: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/student", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddStudents: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/add-students", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  QrCode: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/qr-code", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  PayBill: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  RequestParkingListing: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/parking", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  BookParking: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/bookParking", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  ParkingBookPay: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/bookParking", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  AddMoney: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/wallet", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Address: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/address", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddReview: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/products/rate", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  RegisterMahakumbh: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/mahakumbh", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddTicket: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/support", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddTicketReply: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/support-reply", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ListBusiness: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/listing", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AddVisitor: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/add-listing-visitor", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UploadVideo: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data

        const formData = new FormData();
        console.log(data);

        // Append video file and other data to formData
        formData.append("video", data.video); // `video` is the file object
        formData.append("id", data.id); // `id` is the user ID

        console.log("token", parsedUser.token);
        fetch(env.url + "/upload-video", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + parsedUser.token, // Add Bearer token for authentication
          },
          body: formData, // Use FormData object for the request body
        })
          .then((res) => {
            console.log("res ==", res);

            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then((res) => resolve(res))
          .catch((error) => reject(error));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  VistorCallClicked: (data) => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      //     const parsedUser = JSON.parse(user); // Parse the user data
      fetch(env.url + "/listing-call-clicked", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: 'Bearer ' + parsedUser.token
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  getQr: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/qr-code/get-existing", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => {
            if (res.ok) {
              // If response is successful, parse it as JSON
              return res.json();
            } else {
              // If response status is not 200, check if there's content
              return res.text().then((text) => {
                // If there's text content, try to parse as JSON, otherwise return an error object
                const errorData = text ? JSON.parse(text) : {};
                return {
                  status: res.status,
                  ...errorData,
                };
              });
            }
          })
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  removeMember: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/get-user/" + id + "/members", {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ForgotPassword: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/login/forgot-password", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  VerifyUpdateOtp: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/verify/update-otp", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  UpdatePassword: (password) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/user/update-password", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify({
            password: password.password,
            user_id: parsedUser.id,
          }),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateCardType: (cardType) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/student/${cardType}`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateStudentProfile: (id, data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/student-profile/${id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateMemberProfile: (id, data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/update-member/${id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  JoinMlm: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/mlm_network`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  WithdrawMlmIncome: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/mlm-income`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  WithdrawMlmLevelIncome: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/mlm-income/withdraw-level`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  SwitchPlan: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/switch-affiliate-plan`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  LinkRFID: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/link-rfid`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  AttendanceScan: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/attendance-card`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdatePassword: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/update-user-password`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  UpdateSendOTP: (data) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/update-send-otp`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  SendInquiry: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + `/inquiry`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },
};

export default Post;
